import React from "react";

const DownArrow = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 13 12"
      fill="none"
    >
      <path
        d="M6.92041 0C10.2341 0 12.9204 2.68629 12.9204 6C12.9204 9.31371 10.2341 12 6.92041 12C3.6067 12 0.92041 9.31371 0.92041 6C0.92041 2.68629 3.6067 0 6.92041 0ZM4.20221 4.7818C4.02648 4.95754 4.02648 5.24246 4.20221 5.4182L6.60221 7.8182C6.77795 7.99393 7.06287 7.99393 7.23861 7.8182L9.63861 5.4182C9.81434 5.24246 9.81434 4.95754 9.63861 4.7818C9.46287 4.60607 9.17795 4.60607 9.00221 4.7818L6.92041 6.8636L4.83861 4.7818C4.66287 4.60607 4.37795 4.60607 4.20221 4.7818Z"
        fill={props.active?"#0085FF":props.theme=="dark" || props.theme=="dark-midnight"?"rgb(193, 193, 193)":"gray"}
        fillOpacity={props.active?"":""}
      />
    </svg>
  );
};

export default DownArrow;
